/*
 * ApplicationShiftDetails Messages
 *
 * This contains all the text for the ApplicationShiftDetails component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  participants: {
    id: 'app.containers.ApplicationShiftDetails.participants',
    defaultMessage: 'Participants',
  },
  shiftLeader: {
    id: 'app.containers.ApplicationShiftDetails.shiftLeader',
    defaultMessage: 'Team Leader',
  },
  appliedWithVehicle: {
    id: 'app.containers.ApplicationShiftDetails.appliedWithVehicle',
    defaultMessage: 'Has car available',
  },
  copiedPublisherNamesSuccessfully: {
    id: 'app.containers.ApplicationShiftDetails.copiedPublisherNamesSuccessfully',
    defaultMessage: 'Copied publisher names successfully',
  },
  currentPublisherIsLeader: {
    id: 'app.containers.ApplicationShiftDetails.currentPublisherIsLeader',
    defaultMessage: 'You are assigned as team leader',
  },
  route: {
    id: 'app.containers.ApplicationShiftDetails.route',
    defaultMessage: 'Route',
  },
  location: {
    id: 'app.containers.ApplicationShiftDetails.location',
    defaultMessage: 'Location',
  },
  depot: {
    id: 'app.containers.ApplicationShiftDetails.depot',
    defaultMessage: 'Depot',
  },
  assignedPublishers: {
    id: 'app.containers.ApplicationShiftDetails.assignedPublishers',
    defaultMessage: 'Assigned Publishers',
  },
  turnCanceled: {
    id: 'app.containers.ApplicationShiftDetails.turnCanceled',
    defaultMessage: 'Shift Is Canceled',
  },
  turnCanceledNoReason: {
    id: 'app.containers.ApplicationShiftDetails.turnCanceledNoReason',
    defaultMessage: 'No reason provided, please contact your team leader.',
  },
  cancelShift: {
    id: 'app.containers.ApplicationShiftDetails.cancelShift',
    defaultMessage: 'Cancel shift',
  },
  confirmCancellationTitle: {
    id: 'app.containers.ApplicationShiftDetails.confirmCancellationTitle',
    defaultMessage: 'Cancel shift',
  },
  cancellationLabel: {
    id: 'app.containers.ApplicationShiftDetails.cancellationLabel',
    defaultMessage: 'Cancellation reason',
  },
  confirmCancellation: {
    id: 'app.containers.ApplicationShiftDetails.confirmCancellation',
    defaultMessage: 'Cancel shift',
  },
  cancelCancellation: {
    id: 'app.containers.ApplicationShiftDetails.cancelCancellation',
    defaultMessage: 'Cancel cancellation',
  },
  reportExperience: {
    id: 'app.containers.ApplicationShiftDetails.reportExperience',
    defaultMessage: 'Report experience',
  },
  createTurnReport: {
    id: 'app.containers.ApplicationShiftDetails.createTurnReport',
    defaultMessage: 'Create shift report',
  },
  viewTurnReport: {
    id: 'app.containers.ApplicationShiftDetails.viewTurnReport',
    defaultMessage: 'View shift report',
  },
  closedTurnReport: {
    id: 'app.containers.ApplicationShiftDetails.closedTurnReport',
    defaultMessage: 'Service report closed',
  },
  isCreatingTurnReport: {
    id: 'app.containers.ApplicationShiftDetails.isCreatingTurnReport',
    defaultMessage: 'Creating shift report...',
  },
  createTurnReportSuccess: {
    id: 'app.containers.ApplicationShiftDetails.createTurnReportSuccess',
    defaultMessage: 'Successfully created shift report.',
  },
  createTurnReportFailed: {
    id: 'app.containers.ApplicationShiftDetails.createTurnReportFailed',
    defaultMessage: 'Error. Turn report creation failed.',
  },
  turnLeaders: {
    id: 'app.containers.ApplicationShiftDetails.turnLeaders',
    defaultMessage: 'Turn leaders on this day',
  },
  noAssignmentForThisShift: {
    id: 'app.containers.ApplicationShiftDetails.noAssignmentForThisShift',
    defaultMessage: 'You have no assignments for this shift',
  },
  reportCantBeCreatedAnymore: {
    id: 'app.containers.ApplicationShiftDetails.reportCantBeCreatedAnymore',
    defaultMessage: 'Report cannot be created anymore',
  },
  ok: {
    id: 'app.containers.ApplicationShiftDetails.ok',
    defaultMessage: 'OK',
  },
  contactPlanningTeam: {
    id: 'app.containers.ApplicationShiftDetails.contactPlanningTeam',
    defaultMessage:
      'Please contact the organization team for handing in your report.',
  },
  shiftHasNotStartedYet: {
    id: 'app.containers.ApplicationShiftDetails.shiftHasNotStartedYet',
    defaultMessage:
      'You can create the turn report after your shift has started.',
  },
  reportCantBeCreatedYet: {
    id: 'app.containers.ApplicationShiftDetails.reportCantBeCreatedYet',
    defaultMessage: 'Report cannot be created yet',
  },
});
